import { useQuery, useQueryClient } from "@tanstack/react-query";

import { axios } from "~/core/axios";
import { REACT_QUERY_KEY } from "~/core/constants/common";
import { BackendApiResponse } from "~/core/types/backend-api-response.type";

import { GetPipelinesResponse } from "../types";

export const usePipelinesQuery = () => {
  const { data: pipelines, isLoading: isPipelinesLoading } = useQuery({
    queryKey: [REACT_QUERY_KEY.PIPELINES_OPPORTUNITY_CREATE],
    queryFn: async () => {
      const { data } = await axios.get<
        BackendApiResponse<GetPipelinesResponse[]>
      >("/opportunity-pipelines");
      return data.data;
    },
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });

  return { pipelines, isPipelinesLoading };
};

export const useInvalidatePipelinesQuery = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEY.PIPELINES_OPPORTUNITY_CREATE],
    });
};
